(function() {
  function initAutoScroll() {
    var section = document.querySelector('.collection--full-width');
    if (!section) return;
    var grid = section.querySelector('.product-grid');
    if (!grid) return;
    if (grid.dataset.blInit) return;
    grid.dataset.blInit = '1';

    grid.classList.remove('grid--peek');

    var track = document.createElement('div');
    track.className = 'bl-autoscroll-track';
    track.style.cssText = 'display:flex;width:max-content;will-change:transform;overflow:visible;';
    grid.parentNode.insertBefore(track, grid);
    track.appendChild(grid);

    var clone = grid.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.classList.remove('grid--peek');
    track.appendChild(clone);

    var speed = 0.5;
    var paused = false;
    var pos = 0;
    var singleWidth = 0;
    var measured = false;

    track.addEventListener('mouseenter', function() { paused = true; });
    track.addEventListener('mouseleave', function() { paused = false; });

    function measure() {
      // Messe live: wie weit ist das erste Item des Klons vom ersten Item des Originals?
      // Das ist EXAKT eine Loop-Breite, egal was Shopify-JS an Margins gesetzt hat
      var first1 = grid.querySelector('.grid__item');
      var first2 = clone.querySelector('.grid__item');
      if (!first1 || !first2) return false;
      var d = first2.getBoundingClientRect().left - first1.getBoundingClientRect().left;
      if (d > 100) { // Sanity check
        singleWidth = d;
        return true;
      }
      return false;
    }

    function animate() {
      if (!paused) {
        pos -= speed;
        // Remeasure wenn noetig (nach ersten paar Frames)
        if (!measured && Math.abs(pos) > 50) {
          measured = measure();
        }
        if (singleWidth > 0 && Math.abs(pos) >= singleWidth) {
          pos = pos + singleWidth; // Smooth reset
        }
        track.style.transform = 'translateX(' + pos + 'px)';
      }
      requestAnimationFrame(animate);
    }

    // Starte Animation – messe singleWidth sobald Klon positioniert ist
    setTimeout(function() {
      measured = measure();
      requestAnimationFrame(animate);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoScroll);
  } else {
    initAutoScroll();
  }
})();
